import { init as initSentry } from '@sentry/react'
import { Integrations } from '@sentry/tracing'

export default () => {
  const disableSentry = true // Cookies.get('disable-sentry') === 'true'
  if (!disableSentry) {
    initSentry({
      dsn: '',
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 1.0,
      environment: '',
    })
  }
}
